import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import _ from 'lodash'
import { ColumnsPickerButton } from 'sharedComponents/EditableTableHeader'
import { selectRootUser } from '@/rootSlice'
import { saveTrafficConfig, tabNameToReportKey } from '../trafficReportSlice'
import { trafficSessionsConfig } from 'modules/formatting'
import { reportDefaultInvisibleColumns } from 'modules/reportConfigs'
import { resolveVisibleSortedKeys, parseDefaultInvisibleSet } from '../columnVisibility'

interface Props {
  tabName: string
}

/**
 * Wraps the shared ColumnsPickerButton with Traffic-specific Redux wiring.
 * Lists hidden columns for the active tab and adds them on click via
 * saveTrafficConfig.
 */
export default function TrafficColumnsPickerButton({ tabName }: Props) {
  const dispatch = useDispatch()
  const user: any = useSelector(selectRootUser)
  const reportKey = tabNameToReportKey(tabName)
  if (!reportKey) return null

  const trafficconfig = user?.trafficconfig || { columns: {} }
  const columnConfigs: Record<string, any> = trafficconfig?.columns?.[reportKey] || {}
  const allKeys = trafficSessionsConfig.keys as string[]
  const names = trafficSessionsConfig.titles as Record<string, string>
  const defaultInvisible = parseDefaultInvisibleSet((reportDefaultInvisibleColumns as any)[reportKey])
  const visibleKeys = resolveVisibleSortedKeys(allKeys, columnConfigs, defaultInvisible)

  const onColumnsChange = (partial: any) => {
    const nextColumns = _.merge({}, trafficconfig.columns || {}, partial.columns || {})
    ;(dispatch as any)(saveTrafficConfig({ ...trafficconfig, columns: nextColumns }))
  }

  return (
    <ColumnsPickerButton
      keys={visibleKeys}
      names={names}
      allKeys={allKeys}
      columnConfigs={columnConfigs}
      configKey={reportKey}
      onColumnsChange={onColumnsChange}
    />
  )
}
